import React from 'react';
import clsx from 'clsx';

/**
 * ReactionBubble - Floating Emoji Reaction
 * 
 * Displays emoji reactions that float upward and fade out.
 * Each emoji gets a themed color glow.
 */
const bubbleMap = {
  '❤️': 'text-lounge-neonPink',
  '😍': 'text-lounge-neonPink',
  '😘': 'text-lounge-neonPink',
  '😂': 'text-lounge-neonTeal',
  '🔥': 'text-lounge-accent',
  '🥳': 'text-lounge-neonPurple',
  '✨': 'text-lounge-neonTeal',
  '💯': 'text-lounge-accent',
};

export function ReactionBubble({ emoji, xPercent, id }) {
  const colorClass = bubbleMap[emoji] || 'text-lounge-neonTeal';
  
  // 🔧 FIX: Add randomized float distance for more dynamic movement
  const floatDistance = 50 + Math.random() * 40; // 50-90px upward
  const drift = (Math.random() - 0.5) * 30; // Small horizontal drift

  return (
    <div
      key={id}
      className={clsx(
        'pointer-events-none fixed bottom-16 z-40 select-none'
      )}
      style={{
        left: `${xPercent}%`,
        animation: `lounge-reaction-float 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards`,
        '--float-distance': `${floatDistance}px`,
        '--drift-distance': `${drift}px`,
      }}
    >
      <div
        className={clsx(
          'text-3xl drop-shadow-[0_0_12px_rgba(15,23,42,0.9)]',
          colorClass
        )}
        style={{
          animation: 'lounge-reaction-scale 1.5s ease-out forwards'
        }}
      >
        {emoji}
      </div>
    </div>
  );
}
